import { FC, useCallback } from 'react';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';

import { ViewTypes } from '../types';
import { JsonViewModeContext, JsonViewModeState } from './JsonViewModeContext';

export type ContextProps = {
  defaultMode?: ViewTypes;
  identifier?: string;
};

const STORAGE_KEY = 'json-mode-:id';

export const JsonViewModeContextProvider: FC<React.PropsWithChildren<ContextProps>> = ({
  defaultMode = ViewTypes.table,
  identifier = 'global',
  children,
}) => {
  const [isRawJson, setRawJson] = useLocalStorage(
    STORAGE_KEY.replace(':id', identifier),
    defaultMode === ViewTypes.raw,
  );

  const toggleViewMode = useCallback(() => {
    setRawJson((previous) => !previous);
  }, []);

  const contextValue: JsonViewModeState = {
    isActive: true,
    isRawJson,
    toggleViewMode,
  };

  return (
    <JsonViewModeContext.Provider value={contextValue}>{children}</JsonViewModeContext.Provider>
  );
};
